<template>
  <div
    v-if="hide_menu"
    class="absolute top-[15%] z-[60] bg-gradient-to-br from-blue-500 to-blue-600 p-2 lg:hidden cursor-pointer h-[40px] rounded-r-xl shadow-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-300"
    @click="toggleMenu"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20"
      height="20"
      viewBox="0 0 50 50"
      fill="#fff"
    >
      <path
        d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"
      ></path>
    </svg>
  </div>

  <div
    class="lg:flex fixed w-[95%] bg-white shadow-2xl lg:w-[35%] lg:left-0 overflow-y-auto absolute top-[15%]  h-[calc(109vh-100px)] lg:top-auto xl:w-[30%] 2xl:w-[25%] lg:relative z-30 mt-10 lg:m-10 rounded-3xl lg:h-[calc(100vh-390px)] transition-all duration-300"
    :class="{ hidden: !isMobile }"
     style="box-shadow: 0px 10px 40px 0px rgba(0, 133, 219, 0.15)"
  >
    <div
      @click="toggleSidebar"
      class="absolute top-2 right-[2px] z-30 block lg:hidden bg-blue-100 hover:bg-blue-200 rounded-full p-1 cursor-pointer transition-all duration-200 shadow-md"
    >
      <img src="@/assets/leftaaa.svg" alt="" srcset="" class="w-5 h-5" />
    </div>

    <!-- Header Section -->
    <div class="flex flex-col gap-2 relative w-full overflow-y-auto p-6 ">
      <!-- Profile Summary Card -->
      <div class="mb-6 p-4 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl shadow-lg hidden">
        <div class="flex items-center gap-3">
          <div class="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center ring-2 ring-white/50">
            <img
              v-if="userInfo && userInfo.image && userInfo.image != null"
              :src="userInfo.image"
              class="w-10 h-10 rounded-full object-cover"
            />
            <span v-else class="text-white text-xl font-bold">
              {{ userInfo?.name?.charAt(0) || 'U' }}
            </span>
          </div>
          <div class="flex-1">
            <p class="text-white font-semibold text-sm">{{ userInfo?.name || 'Student' }}</p>
            <p class="text-white/70 text-xs">Student Dashboard</p>
          </div>
        </div>
      </div>

      <!-- Navigation Items -->
      <div class="space-y-2">
        <router-link
          :to="{ name: 'PreviewStudentCourseProgress' }"
          class="flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200 group"
          :class="{
            'bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg shadow-blue-200': $route.name == 'PreviewStudentCourseProgress',
            'hover:bg-blue-50': $route.name != 'PreviewStudentCourseProgress',
          }"
        >
          <div class="w-6 h-6 flex items-center justify-center">
            <img
              src="@/assets/newd/icons/Grid.png"
              v-if="$route.name == 'PreviewStudentCourseProgress'"
              alt=""
              class="w-5 h-5 brightness-0 invert"
            />
            <img
              src="@/assets/newd/icons/Grid-1.png"
              v-if="$route.name != 'PreviewStudentCourseProgress'"
              alt=""
              class="w-5 h-5 opacity-70 group-hover:opacity-100"
            />
          </div>
          <p
            class="font-semibold text-sm"
            :class="{
              'text-white': $route.name == 'PreviewStudentCourseProgress',
              'text-gray-700': $route.name != 'PreviewStudentCourseProgress',
            }"
          >
            Lessons
          </p>
        </router-link>

        <router-link
          v-if="checkinTheList('Messages')"
          :to="{ name: 'PreviewStudentNewMessages' }"
          class="flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200 group"
          :class="{
            'bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg shadow-blue-200': $route.name == 'PreviewStudentNewMessages',
            'hover:bg-blue-50': $route.name != 'PreviewStudentNewMessages',
          }"
        >
          <div class="w-6 h-6 flex items-center justify-center">
            <img
              src="@/assets/newd/icons/mdi-light_forum-1.png"
              v-if="$route.name == 'PreviewStudentNewMessages'"
              alt=""
              class="w-5 h-5 brightness-0 invert"
            />
            <img
              src="@/assets/newd/icons/mdi-light_forum.png"
              v-if="$route.name != 'PreviewStudentNewMessages'"
              alt=""
              class="w-5 h-5 opacity-70 group-hover:opacity-100"
            />
          </div>
          <p
            class="font-semibold text-sm"
            :class="{
              'text-white': $route.name == 'PreviewStudentNewMessages',
              'text-gray-700': $route.name != 'PreviewStudentNewMessages',
            }"
          >
            Messages
          </p>
        </router-link>

        <router-link
          v-if="checkinTheList('Assignments')"
          :to="{ name: 'PreviewStudentAssignments' }"
          class="flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200 group"
          :class="{
            'bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg shadow-blue-200': assignMentActive,
            'hover:bg-blue-50': !assignMentActive,
          }"
        >
          <div class="w-6 h-6 flex items-center justify-center">
            <img
              src="@/assets/newd/icons/gg_notes-1.png"
              v-if="assignMentActive"
              alt=""
              class="w-5 h-5 brightness-0 invert"
            />
            <img
              src="@/assets/newd/icons/gg_notes.png"
              v-if="!assignMentActive"
              alt=""
              class="w-5 h-5 opacity-70 group-hover:opacity-100"
            />
          </div>
          <p
            class="font-semibold text-sm"
            :class="{
              'text-white': assignMentActive,
              'text-gray-700': !assignMentActive,
            }"
          >
            Assignments
          </p>
        </router-link>

        <router-link
          v-if="checkinTheList('Messages')"
          :to="{ name: 'PreviewStudentNewForums' }"
          class="flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200 group"
          :class="{
            'bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg shadow-blue-200': $route.name == 'PreviewStudentNewForums',
            'hover:bg-blue-50': $route.name != 'PreviewStudentNewForums',
          }"
        >
          <div class="w-6 h-6 flex items-center justify-center">
            <img
              src="@/assets/newd/icons/Archive-1.png"
              v-if="$route.name == 'PreviewStudentNewForums'"
              alt=""
              class="w-5 h-5 brightness-0 invert"
            />
            <img
              src="@/assets/newd/icons/Archive.png"
              v-if="$route.name != 'PreviewStudentNewForums'"
              alt=""
              class="w-5 h-5 opacity-70 group-hover:opacity-100"
            />
          </div>
          <p
            class="font-semibold text-sm"
            :class="{
              'text-white': $route.name == 'PreviewStudentNewForums',
              'text-gray-700': $route.name != 'PreviewStudentNewForums',
            }"
          >
            Forums
          </p>
        </router-link>

        <router-link
          :to="{ name: 'PreviewStudentClasses' }"
          class="flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200 group"
          :class="{
            'bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg shadow-blue-200': $route.name == 'PreviewStudentClasses',
            'hover:bg-blue-50': $route.name != 'PreviewStudentClasses',
          }"
        >
          <div class="w-6 h-6 flex items-center justify-center">
            <img
              src="@/assets/newd/icons/Calendar2Week-1.png"
              v-if="$route.name == 'PreviewStudentClasses'"
              alt=""
              class="w-5 h-5 brightness-0 invert"
            />
            <img
              src="@/assets/newd/icons/Calendar2Week.png"
              v-if="$route.name != 'PreviewStudentClasses'"
              alt=""
              class="w-5 h-5 opacity-70 group-hover:opacity-100"
            />
          </div>
          <p
            class="font-semibold text-sm"
            :class="{
              'text-white': $route.name == 'PreviewStudentClasses',
              'text-gray-700': $route.name != 'PreviewStudentClasses',
            }"
          >
            Live Classes
          </p>
        </router-link>

        <router-link
          v-if="checkinTheList('Assessment')"
          :to="{ name: 'PreviewStudentAssessments' }"
          class="flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200 group"
          :class="{
            'bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg shadow-blue-200': $route.name == 'PreviewStudentAssessments',
            'hover:bg-blue-50': $route.name != 'PreviewStudentAssessments',
          }"
        >
          <div class="w-6 h-6 flex items-center justify-center">
            <img
              src="@/assets/newd/icons/BarChartLine-1.png"
              v-if="$route.name == 'PreviewStudentAssessments'"
              alt=""
              class="w-5 h-5 brightness-0 invert"
            />
            <img
              src="@/assets/newd/icons/BarChartLine.png"
              v-if="$route.name != 'PreviewStudentAssessments'"
              alt=""
              class="w-5 h-5 opacity-70 group-hover:opacity-100"
            />
          </div>
          <p
            class="font-semibold text-sm"
            :class="{
              'text-white': $route.name == 'PreviewStudentAssessments',
              'text-gray-700': $route.name != 'PreviewStudentAssessments',
            }"
          >
            Assessment
          </p>
        </router-link>

        <router-link
          v-if="checkinTheList('Projects')"
          :to="{ name: 'PreviewStudentProject' }"
          class="flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200 group"
          :class="{
            'bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg shadow-blue-200': $route.name == 'PreviewStudentProject',
            'hover:bg-blue-50': $route.name != 'PreviewStudentProject',
          }"
        >
          <div class="w-6 h-6 flex items-center justify-center">
            <img
              src="@/assets/newd/icons/gg_notes-1.png"
              v-if="$route.name == 'PreviewStudentProject'"
              alt=""
              class="w-5 h-5 brightness-0 invert"
            />
            <img
              src="@/assets/newd/icons/gg_notes.png"
              v-if="$route.name != 'PreviewStudentProject'"
              alt=""
              class="w-5 h-5 opacity-70 group-hover:opacity-100"
            />
          </div>
          <p
            class="font-semibold text-sm"
            :class="{
              'text-white': $route.name == 'PreviewStudentProject',
              'text-gray-700': $route.name != 'PreviewStudentProject',
            }"
          >
            Projects
          </p>
        </router-link>

        <!-- External Links Section -->
        <div class="pt-4 mt-2 border-t border-gray-200">
          <a
            href="https://au-exams.galecta.com"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200 group hover:bg-blue-50"
          >
            <div class="w-6 h-6 flex items-center justify-center">
              <img src="@/assets/newd/icons/Archive.png" alt="Support" class="w-5 h-5 opacity-70 group-hover:opacity-100" />
            </div>
            <p class="font-semibold text-sm text-gray-700 group-hover:text-blue-600">Tickets</p>
          </a>

          <a
            href="https://onlineexams.alliance.edu.in"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-200 group hover:bg-blue-50"
          >
            <div class="w-6 h-6 flex items-center justify-center">
              <img src="@/assets/newd/icons/gg_notes.png" alt="Support" class="w-5 h-5 opacity-70 group-hover:opacity-100" />
            </div>
            <p class="font-semibold text-sm text-gray-700 group-hover:text-blue-600">Semester Exam</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isMobile: false,
      hide_menu: true,
      permisson_list: [],
    };
  },

  computed: {
    ...mapGetters(["isAuthenticated", "userInfo", "permissionList"]),

    assignMentActive() {
      return (
        this.$route.name == "PreviewStudentAssignments" ||
        this.$route.name == "PreviewAssignmentDetail"
      );
    },
  },

  methods: {
    checkinTheList(feature) {
      let check = this.permissionList.find((x) => x === feature);
      if (check != undefined) {
        return true;
      } else {
        return false;
      }
    },

    toggleSidebar() {
      this.isMobile = false;
      this.hide_menu = true;
    },
    toggleMenu() {
      this.isMobile = !this.isMobile;
      this.hide_menu = !this.isMobile;
    },
  },
};
</script>

<style scoped>
img {
  width: 20px;
  height: 20px;
}

.heightfix {
  height: calc(100vh - 390px) !important;
}

/* Custom scrollbar */
.heightfix::-webkit-scrollbar {
  width: 5px;
}

.heightfix::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.heightfix::-webkit-scrollbar-thumb {
  background: #0085DB;
  border-radius: 10px;
}

.heightfix::-webkit-scrollbar-thumb:hover {
  background: #0066a8;
}
</style>